import StackItemController from './stack-item.controller';
import { IStackItem } from './stack-item.model';

const StackItem = (props: IStackItem) => {
  return <StackItemController {...props} />;
};

export default StackItem;
